<footer class="footer">
  <div class="footer-inner">
    <div class="footer-grid">
      <div>
        <img src="/assets/img/logo.svg" alt="" width="34" height="34" />
        <div class="footer-name">{{ 'footer.brandName' | translate }}</div>
        <div class="footer-tag">{{ 'footer.brandMeta' | translate }}</div>
      </div>
      <div>
        <div ppcEyebrow class="footer-col-key">{{ 'footer.contactLabel' | translate }}</div>
        <div class="footer-col-val">
          <a [href]="'tel:' + ('company.phoneHref' | translate)">{{ 'company.phone' | translate }}</a
          ><br />
          <span class="footer-dim">{{ 'company.email' | translate }}</span>
        </div>
      </div>
      <div>
        <div ppcEyebrow class="footer-col-key">{{ 'footer.addressLabel' | translate }}</div>
        <div class="footer-col-val footer-dim">
          {{ 'company.addressLine' | translate }}<br />{{ 'company.addressCity' | translate }}
        </div>
      </div>
      <div>
        <div ppcEyebrow class="footer-col-key">{{ 'footer.followLabel' | translate }}</div>
        <div class="footer-socials">
          <a
            class="footer-social"
            [href]="'company.facebook' | translate"
            target="_blank"
            rel="noreferrer"
            >{{ 'footer.social.facebook' | translate }}</a
          >
          <a
            class="footer-social"
            [href]="'company.instagram' | translate"
            target="_blank"
            rel="noreferrer"
            >{{ 'footer.social.instagram' | translate }}</a
          >
        </div>
      </div>
    </div>

    <div ppcHeading size="lg" class="footer-giant">{{ 'footer.bigBrand' | translate }}</div>

    <div class="footer-legal">
      <span>© {{ year }} {{ 'footer.brandName' | translate }}</span>
      <span>{{ 'footer.tagline' | translate }}</span>
      <span>{{ 'footer.cityPrefix' | translate }}{{ 'company.founded' | translate }}</span>
    </div>
  </div>
</footer>
